import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError, from, switchMap, catchError } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getIdToken();

    const protectedApiUrls = [
      environment.recruitment.apiUrl,
      environment.questions.apiUrl,
      environment.admin.apiUrl,
      environment.uploader.apiUrl,
    ].filter(Boolean);
    const isPresignedRequest = /[?&]X-Amz-(?:Algorithm|Credential|Signature)=/i.test(req.url);
    const isPublicRecruitmentLinkRequest = !!environment.recruitment.publicLinkUrl &&
      req.url === environment.recruitment.publicLinkUrl;
    const isProtectedRequest = !isPresignedRequest && !isPublicRecruitmentLinkRequest &&
      protectedApiUrls.some((apiUrl) => req.url.startsWith(apiUrl));
    const authReq = token && isProtectedRequest ? this.addToken(req, token) : req;

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        // 401 → try refreshing once, then logout
        if (error.status === 401 && token && isProtectedRequest) {
          return from(this.authService.refreshSession()).pipe(
            switchMap((newToken) => next.handle(this.addToken(req, newToken))),
            catchError(() => {
              this.authService.logout();
              return throwError(() => error);
            })
          );
        }
        return throwError(() => error);
      })
    );
  }

  private addToken(req: HttpRequest<any>, token: string): HttpRequest<any> {
    return req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }
}
